
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { ComputerService } from './computer.service';
import { ToastFactory } from '@/utils/ToastFactory';
const computerService = new ComputerService();

export default defineComponent({
    name: 'ListComputers',
    data() {
        return {
            computersTotal: 0,
            computers: [],
            params:{ name:"", page: 0, size: 6, total: 0 },
            filters: null as any

        }
    },

    computed: {
        ...mapGetters({
            storeComputers: 'computers/getComputers',
        })
    },

    methods: {
        paginate(event: {page: number, rows: number}): void {
            this.getComputers(this.params.name, event.page, event.rows)
        },

        getComputers(name: string, page: number, size: number){
            computerService.getComputers({name, page, size}).then(() => {
                this.computers = this.storeComputers.content;
                this.params.total = this.storeComputers.total;
            });
        },

        getAlLicensesDatabase(page: number, size: number){
            computerService.getComputers({page, size}).then(() => {
                this.computersTotal = this.storeComputers.total;    
            });
        },

        computersPaginated(): void {
            const page = this.params.page;
            const size = this.params.size;
            const name = this.params.name;
            this.getComputers(name, page, size);
        },

        isActive(value: boolean){
            if(value && navigator.language === 'pt-BR'){
                return 'Ativo';
            } else if(value && navigator.language === 'en-US'){
                return 'Active';
            } else if(!value && navigator.language === 'pt-BR'){
                return 'Inativo';
            } else if(!value && navigator.language === 'en-US'){
                return 'Inactive';
            }
        },

        deleteComputer(id: string){
            computerService.deleteComputer(id).then(() => {
                this.computersPaginated();
                this.$toast.add(ToastFactory.success(this.$t("toast.sucessEquipDelete")));
            }).catch(() => {
                this.$toast.add(ToastFactory.error(this.$t("toast.errorEquipDelete")));
            })
        },

        confirmDelete(id: any){
            this.$confirm.require({
                header: this.$t('computer.delete'),
                message: this.$t('computer.confirmDelete'),
                accept: () => {
                    this.deleteComputer(id);
                },
                reject: () => {
                    console.log('reject');
                }
            });
        },
    },

    mounted() {
        this.computersPaginated();
        this.getAlLicensesDatabase(this.params.page, this.params.size);
    }
});
